import {initPageLight} from "./init-page-light";
import {initPlaceholderPage} from "./init-placeholder-page";

window.addEventListener(`load`, () => {
  initPageLight();
  initPlaceholderPage();
});
